import { faEye } from "@fortawesome/free-solid-svg-icons/faEye";
import type { ImageProps } from "../utils/local-antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { Image } from "../utils/local-antd";

import { AtiraIcon } from "./AtiraIcon";
import { Flex } from "./Flex";
import { Text } from "./Text";

export interface AtiraImageProps extends ImageProps {
  width?: string | number;
  height?: string | number;
  src: string;
  onClick?: () => void;
  style?: React.CSSProperties;
}

export const AtiraImage: React.FC<AtiraImageProps> = ({
  width = "100%",
  height,
  src,
  onClick,
  style,
  preview,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <Image
      referrerPolicy="no-referrer"
      alt="atira_image"
      src={src}
      width={width}
      height={height}
      onClick={onClick}
      style={style}
      preview={
        preview
          ? {
              mask: (
                <Flex
                  alignItems="center"
                  gap="s"
                  className="image-preview-container"
                >
                  <AtiraIcon icon={faEye} />
                  <Text color="white">{t("common.preview")}</Text>
                </Flex>
              ),
              toolbarRender: () => null,
            }
          : false
      }
      {...props}
    />
  );
};
